import { sendMatomoEvent } from "../../utils"

export const trackProgramFilterClick = (tag: string) => {
	sendMatomoEvent({
		event: "Filter Show Page",
		analyticsInfo: tag
	})
}
